import { CSS as CheckBoxCSS } from '../../components/input/input.checkbox';
import { CSS as TagIconCSS } from '../tag.icon/tag.icon.style';

export const CSS = {
	container: 'c-TagCardCheckbox',
	hasSelections: 'c-TagCardCheckbox__has-selections',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
	},
	[`${CSS.container} .${CheckBoxCSS.container}`]: {
		display: 'none',
		width: 'inherit',
		height: 'inherit',
	},
	[`${CSS.container}:hover .${TagIconCSS.container}`]: {
		display: 'none',
	},
	[`${CSS.container}:hover .${CheckBoxCSS.container}`]: {
		display: 'flex',
	},
	[`${CSS.container}.${CSS.hasSelections} .${CheckBoxCSS.container}`]: {
		display: 'flex',
	},
};
